exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SessionCard-module__left___37FH0{display:grid;grid-template-columns:auto 1fr;gap:1rem}.SessionCard-module__left___37FH0 *{line-height:1.2}.SessionCard-module__left___37FH0 .SessionCard-module__bar___2iMfF{background-color:#fff;height:100%;width:1px}.SessionCard-module__left___37FH0 .SessionCard-module__title___3hSaa{display:grid;grid-auto-flow:column;gap:.5rem;align-items:center;justify-content:start}.SessionCard-module__left___37FH0 .SessionCard-module__title___3hSaa svg{transform:translateY(-1px);font-size:18px;color:#2addd0}.SessionCard-module__left___37FH0 .SessionCard-module__lesson___3VKyf{font-size:14px}", ""]);

// exports
exports.locals = {
	"left": "SessionCard-module__left___37FH0",
	"bar": "SessionCard-module__bar___2iMfF",
	"title": "SessionCard-module__title___3hSaa",
	"lesson": "SessionCard-module__lesson___3VKyf"
};